(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7575],{

/***/ 43818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.c = function IoCheckmarkCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"}}]})(props);
};


/***/ }),

/***/ 23100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AdSlotBase */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8002);




var AdSlotBase = function(param) {
    var data = param.data;
    var slot = data;
    if (!(slot === null || slot === void 0 ? void 0 : slot.slotId) || !_config_constants__WEBPACK_IMPORTED_MODULE_1__/* .ADSENSE_ID */ .jf) {
        return null;
    }
    var props = {};
    if (slot === null || slot === void 0 ? void 0 : slot.responsive) {
        props["data-full-width-responsive"] = "true";
    }
    if (slot === null || slot === void 0 ? void 0 : slot.layout) {
        props["data-ad-layout"] = slot === null || slot === void 0 ? void 0 : slot.layout;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        width: "100%",
        minHeight: (slot === null || slot === void 0 ? void 0 : slot.maxHeight) ? "".concat(slot === null || slot === void 0 ? void 0 : slot.maxHeight, "px") : "auto",
        my: {
            base: 4,
            md: 6
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                className: "adsbygoogle",
                style: {
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    textAlign: "center"
                },
                "data-ad-client": "ca-pub-".concat(_config_constants__WEBPACK_IMPORTED_MODULE_1__/* .ADSENSE_ID */ .jf),
                "data-ad-slot": slot === null || slot === void 0 ? void 0 : slot.slotId,
                "data-ad-format": (slot === null || slot === void 0 ? void 0 : slot.format) || "auto"
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "(adsbygoogle = window.adsbygoogle || []).push({});"
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdSlotBase);


/***/ }),

/***/ 21097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23887);





var Image = function(_param) {
    var imageStyle = _param.imageStyle, image = _param.image, hideCopyright = _param.hideCopyright, wrapperProps = _param.wrapperProps, description = _param.description, copyrightInside = _param.copyrightInside, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "imageStyle",
        "image",
        "hideCopyright",
        "wrapperProps",
        "description",
        "copyrightInside"
    ]);
    if (!imageStyle) return null;
    var showCopyright = !hideCopyright && image.copyright;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "image-".concat(image.id),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                pos: "relative"
            }, wrapperProps), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Img */ .Ei, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        htmlWidth: imageStyle.width,
                        htmlHeight: imageStyle.height,
                        src: imageStyle.url,
                        width: "100%",
                        loading: "lazy",
                        alt: image.alt || ""
                    }, props)),
                    showCopyright && copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                        pos: "absolute",
                        left: 0,
                        bottom: 0,
                        bg: "rgba(0,0,0, .4)",
                        color: "white",
                        p: 1,
                        fontSize: "xxs",
                        children: [
                            "Foto \xa9 ",
                            image.copyright
                        ]
                    })
                ]
            })),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                pt: 1,
                fontSize: "md",
                children: description
            }),
            showCopyright && !copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                fontSize: "xxs",
                children: [
                    "Foto \xa9 ",
                    image.copyright
                ]
            })
        ]
    });
};


/***/ }),

/***/ 50303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ImageSlider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23887);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30719);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);








// CSS


var InnerImage = function(param) {
    var image = param.image, url = param.url, hideCopyright = param.hideCopyright;
    var Image = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        pos: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Img */ .Ei, {
                width: "100%",
                src: image.imageStyle.url,
                htmlWidth: image.imageStyle.width,
                htmlHeight: image.imageStyle.height,
                alt: image.alt || "",
                loading: "lazy"
            }),
            !hideCopyright && image.copyright && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                pos: "absolute",
                left: 0,
                bottom: 0,
                bg: "rgba(0,0,0, .4)",
                color: "white",
                p: 1,
                fontSize: "xxs",
                children: image.copyright
            })
        ]
    });
    return url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: url,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: Image
        })
    }) : Image;
};
var ImageSlider = function(_param) {
    var images = _param.images, url = _param.url, hideCopyright = _param.hideCopyright, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "images",
        "url",
        "hideCopyright"
    ]);
    if (images.length === 1) {
        var image = images[0];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerImage, {
                hideCopyright: hideCopyright,
                image: image,
                url: url
            })
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        __css: {
            ".swiper-pagination-bullet": {
                border: "1px solid #fff",
                width: "12px",
                height: "12px",
                bg: "rgba(0,0,0, .4)",
                opacity: 1
            },
            ".swiper-pagination-bullet-active": {
                bg: "#fff"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
            modules: [
                swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl
            ],
            pagination: {
                clickable: true
            },
            slidesPerView: 1,
            children: images.map(function(image, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerImage, {
                        hideCopyright: hideCopyright,
                        image: image,
                        url: url
                    })
                }, i);
            })
        })
    }));
};


/***/ }),

/***/ 45387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ StaticAdSlot; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40353);
/* harmony import */ var _AdSlotBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23100);




var StaticAdSlot = function(param) {
    var adKey = param.adKey;
    var ref;
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_2__/* .PageContext */ .z);
    if (!((ref = pageContext.adSlots) === null || ref === void 0 ? void 0 : ref[adKey])) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AdSlotBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        data: pageContext.adSlots[adKey]
    });
};


/***/ }),

/***/ 5885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FarmCategoryListGrouped; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52494);
/* harmony import */ var _react_icons_all_files_io5_IoCheckmarkCircle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43818);



var FarmCategoryListGrouped = function(param) {
    var categories = param.categories, categoryIds = param.categoryIds;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Wrap */ .Eq, {
        direction: {
            base: "column",
            md: "row"
        },
        spacing: 4,
        children: categories.map(function(categoryParagraph, i) {
            if (!categoryParagraph.category.showOnFarm) return null;
            if (categoryIds && !categoryIds.includes(categoryParagraph.category.id)) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .WrapItem */ .Uc, {
                flexDirection: "column",
                color: "primary",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        fontWeight: "bold",
                        children: categoryParagraph.category.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        ml: 4,
                        mt: 2,
                        children: categoryParagraph.subCategories.map(function(subCategory, j) {
                            if (!subCategory.showOnFarm) return null;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                            mr: 1,
                                            fontSize: "xl",
                                            as: _react_icons_all_files_io5_IoCheckmarkCircle__WEBPACK_IMPORTED_MODULE_3__/* .IoCheckmarkCircle */ .c,
                                            color: "primary"
                                        }),
                                        subCategory.title
                                    ]
                                })
                            }, j);
                        })
                    })
                ]
            }, i);
        })
    });
};


/***/ }),

/***/ 57575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Farm": function() { return /* reexport */ Farm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/components/Layout/Metatags.tsx
var Metatags = __webpack_require__(58005);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmPremiumMenu.tsx
var FarmPremiumMenu = __webpack_require__(15013);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmHeader.tsx
var FarmHeader = __webpack_require__(86479);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmRatings.tsx + 37 modules
var FarmRatings = __webpack_require__(11382);
// EXTERNAL MODULE: ./src/components/Paragraph/ParagraphRenderer.tsx
var ParagraphRenderer = __webpack_require__(67025);
// EXTERNAL MODULE: ./src/components/Common/Image.tsx
var Image = __webpack_require__(21097);
// EXTERNAL MODULE: ./src/components/Common/ImageSlider.tsx
var ImageSlider = __webpack_require__(50303);
;// CONCATENATED MODULE: ./src/components/Node/Farm/FarmImages.tsx





var FarmImages = function(param) {
    var data = param.data;
    var images = (0,react.useMemo)(function() {
        var ref;
        var images = [];
        if (data.teaserImage) {
            images.push(data.teaserImage);
        }
        (ref = data.images) === null || ref === void 0 ? void 0 : ref.forEach(function(image) {
            return images.push(image);
        });
        return images;
    }, [
        data
    ]);
    if (!images.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                display: {
                    base: "block",
                    md: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* ImageSlider */.x, {
                    images: images
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                display: {
                    base: "none",
                    md: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                    templateColumns: "repeat(12, 1fr)",
                    gap: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                            rowSpan: images.length > 2 ? 2 : 1,
                            colSpan: images.length > 1 ? 8 : 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                imageStyle: images[0].imageStyle,
                                image: images[0],
                                copyrightInside: true
                            })
                        }),
                        images.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        imageStyle: images[1].imageStyle,
                                        image: images[1],
                                        copyrightInside: true
                                    })
                                }),
                                images.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        imageStyle: images[2].imageStyle,
                                        image: images[2],
                                        copyrightInside: true
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Node/Farm/FarmDescription.tsx


var FarmDescription = function(param) {
    var data = param.data;
    if (!data.farmDescription) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        mt: 3,
        mb: 9,
        dangerouslySetInnerHTML: {
            __html: data.farmDescription
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./src/components/Teaser/FarmTeaser.tsx + 1 modules
var FarmTeaser = __webpack_require__(85441);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronForward.js
var IoChevronForward = __webpack_require__(18935);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Node/Farm/FarmNearPremiumFarms.tsx





var FarmNearPremiumFarms = function(param) {
    var data = param.data;
    var ref, ref1, ref2;
    if (!((ref = data.nearPremiumFarms) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                    maxW: "container.main",
                    py: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        fontFamily: "body",
                        as: "h3",
                        fontSize: "2xl",
                        color: "primary",
                        fontWeight: "bold",
                        children: "Trabland Premium Partner in der N\xe4he"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                maxW: "container.main",
                py: 6,
                borderTop: "1px solid",
                borderTopColor: "gray.300",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                        alignItems: "flex-start",
                        spacing: 9,
                        divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* StackDivider */.cX, {
                            borderColor: "gray.300"
                        }),
                        children: (ref2 = data.nearPremiumFarms) === null || ref2 === void 0 ? void 0 : ref2.items.map(function(farm) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTeaser/* FarmTeaser */.S, {
                                data: farm
                            }, farm.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
                        my: 6
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/mediadaten",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                width: {
                                    base: "100%",
                                    md: "auto"
                                },
                                justifyContent: {
                                    base: "center",
                                    md: "flex-start"
                                },
                                as: "a",
                                layerStyle: "link_button_blue",
                                fontSize: {
                                    base: "sm",
                                    md: "md"
                                },
                                children: [
                                    "Jetzt Premium Partner werden",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                        ml: 1,
                                        as: IoChevronForward/* IoChevronForward */.m
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Node/Farm/FarmCategoryListGrouped.tsx
var FarmCategoryListGrouped = __webpack_require__(5885);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmContact.tsx + 1 modules
var FarmContact = __webpack_require__(7622);
// EXTERNAL MODULE: ./src/context/FarmContext.ts
var FarmContext = __webpack_require__(66771);
// EXTERNAL MODULE: ./src/components/Common/StaticAdSlot.tsx
var StaticAdSlot = __webpack_require__(45387);
;// CONCATENATED MODULE: ./src/components/Node/Farm/Farm.tsx

















var Farm = function(param) {
    var data = param.data;
    var ref;
    var isAddress = data.listingType.title === "Address";
    var isBasic = data.listingType.title === "Basic";
    var isPremium = data.listingType.title === "Premium";
    var adjustedMetatags = (0,react.useMemo)(function() {
        var metatagsWithTitleTransformed = data.metatags.map(function(tag) {
            // we have readonly properties, so create a new one here to be able to adjust
            var newTag = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                attributes: (0,_object_spread/* default */.Z)({}, tag.attributes)
            });
            if (newTag.tag === "title") {
                newTag.attributes.content = "".concat(data.title, " in ").concat(data.address.postcode, " ").concat(data.address.city);
            }
            return newTag;
        });
        // check if we have description metatag
        var descriptionMetaTag = metatagsWithTitleTransformed.find(function(tag) {
            return tag.tag === "meta" && tag.attributes.name === "description";
        });
        var description = data.title;
        var categories = data.categories.filter(function(category) {
            return category.category.title === "Betriebsart";
        });
        if (categories.length > 0) {
            description += " | ";
            categories.forEach(function(category, i) {
                var ref;
                (ref = category.subCategories) === null || ref === void 0 ? void 0 : ref.forEach(function(subCategory, j) {
                    description += "✓ ".concat(subCategory.title);
                    if (j !== category.subCategories.length - 1) {
                        description += " ";
                    }
                });
            });
        }
        description += " | ► Jetzt hier mehr erfahren!";
        if (descriptionMetaTag) {
            descriptionMetaTag.attributes.content = description;
        } else {
            metatagsWithTitleTransformed.push({
                __typename: "Metatag",
                tag: "meta",
                attributes: {
                    __typename: "MetatagAttribute",
                    name: "description",
                    content: description
                }
            });
        }
        return metatagsWithTitleTransformed;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Metatags/* Metatags */.A, {
                metatags: adjustedMetatags
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmHeader/* FarmHeader */.y, {
                data: data
            }),
            isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmPremiumMenu/* FarmPremiumMenu */.x, {
                data: data
            }),
            isAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                maxW: "container.main",
                py: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCategoryListGrouped/* FarmCategoryListGrouped */.l, {
                    categories: data.categories.filter(function(category) {
                        return category.category.title === "Betriebsart";
                    })
                })
            }),
            isAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticAdSlot/* StaticAdSlot */.z, {
                adKey: "in_content_1"
            }),
            isAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmContact/* FarmContact */.d, {
                data: data
            }),
            isAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticAdSlot/* StaticAdSlot */.z, {
                adKey: "in_content_2"
            }),
            ((ref = data.content) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmContext/* FarmContext.Provider */.z.Provider, {
                value: {
                    farm: data
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphRenderer/* ParagraphRenderer */.W, {
                    paragraphs: data.content
                })
            }),
            isAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmNearPremiumFarms, {
                data: data
            }),
            !isAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                maxW: "container.main",
                py: 6,
                children: [
                    isBasic && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmImages, {
                        data: data
                    }),
                    isBasic && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmDescription, {
                        data: data
                    })
                ]
            }),
            isBasic && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                maxW: "container.main",
                py: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCategoryListGrouped/* FarmCategoryListGrouped */.l, {
                    categories: data.categories
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmRatings/* FarmRatings */.x, {
                data: data
            }),
            !isAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmContact/* FarmContact */.d, {
                data: data
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Node/Farm/index.ts



/***/ }),

/***/ 85441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ FarmTeaser; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Common/ImageSlider.tsx
var ImageSlider = __webpack_require__(50303);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io/IoMdPin.js
var IoMdPin = __webpack_require__(82247);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronForward.js
var IoChevronForward = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/components/Common/Rating.tsx
var Rating = __webpack_require__(81926);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoCheckmarkCircle.js
var IoCheckmarkCircle = __webpack_require__(43818);
;// CONCATENATED MODULE: ./src/components/Node/Farm/FarmCategoryList.tsx




var FarmCategoryList = function(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
        direction: "row",
        alignItems: "center",
        flexWrap: "wrap",
        divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* StackDivider */.cX, {
            borderColor: "gray.300"
        }),
        spacing: 2,
        fontSize: {
            base: "sm",
            md: "md"
        },
        children: categories.map(function(categoryParagraph, i) {
            var allCategories = [
                categoryParagraph.category, 
            ].concat((0,_to_consumable_array/* default */.Z)(categoryParagraph.subCategories)).filter(function(category) {
                return category.showInTeaser;
            });
            return allCategories.map(function(cat, j) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                            mr: 1,
                            fontSize: "md",
                            as: IoCheckmarkCircle/* IoCheckmarkCircle */.c,
                            color: "primary"
                        }),
                        cat.title
                    ]
                }, j);
            });
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Teaser/FarmTeaser.tsx









var FarmTeaser = function(param) {
    var data = param.data;
    var images = (0,react.useMemo)(function() {
        var ref;
        var images = [];
        if (data.teaserImage) {
            images.push(data.teaserImage);
        }
        (ref = data.images) === null || ref === void 0 ? void 0 : ref.forEach(function(image) {
            return images.push(image);
        });
        return images;
    }, [
        data
    ]);
    var isPremium = data.listingType.title === "Premium";
    var isAddress = data.listingType.title === "Address";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
            templateColumns: "repeat(12, 1fr)",
            templateRows: {
                base: "repeat(1, 1fr)",
                md: "auto 1fr"
            },
            columnGap: {
                base: isPremium ? 0 : 3,
                md: 6
            },
            rowGap: {
                base: 0,
                md: 0
            },
            width: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                    rowSpan: 2,
                    colSpan: {
                        base: isPremium ? 12 : 4,
                        md: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        pos: "relative",
                        overflow: "hidden",
                        children: [
                            isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                textTransform: "uppercase",
                                pos: "absolute",
                                px: 8,
                                left: "-38px",
                                top: "38px",
                                zIndex: 2,
                                bg: "secondary",
                                color: "#fff",
                                fontSize: "sm",
                                fontWeight: "bold",
                                transform: "rotate(-35deg)",
                                children: "Trabland Premium"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                justifyContent: {
                                    base: "center",
                                    md: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* ImageSlider */.x, {
                                    maxW: {
                                        base: "100%",
                                        md: !isPremium ? "60%" : "100%"
                                    },
                                    images: images,
                                    url: data.url,
                                    hideCopyright: true
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                    colSpan: {
                        base: isPremium ? 12 : 8,
                        md: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: data.url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                display: "block",
                                as: "a",
                                fontSize: {
                                    base: "lg",
                                    md: "xl"
                                },
                                fontWeight: "bold",
                                mt: {
                                    base: isPremium ? 2 : 0,
                                    md: 0
                                },
                                color: "primary",
                                _hover: {
                                    color: "primaryDark"
                                },
                                children: data.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                fontSize: "sm",
                                alignItems: "center",
                                mt: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                        fontSize: "lg",
                                        mr: 1,
                                        as: IoMdPin/* IoMdPin */.Q,
                                        color: "primary"
                                    }),
                                    data.address.postcode,
                                    " ",
                                    data.address.city
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                    colSpan: {
                        base: 12,
                        md: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            mt: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCategoryList, {
                                categories: data.categories
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            mt: 2,
                            color: "gray.600",
                            fontSize: "sm",
                            children: data.teaserText
                        }),
                        data.voteCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                            alignItems: "center",
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                                        initialRating: data.voteAverage,
                                        readonly: true,
                                        iconProps: {
                                            fontSize: "xl"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        ml: 2,
                                        mt: "-6px",
                                        fontSize: "sm",
                                        children: [
                                            "(",
                                            data.voteCount,
                                            " Bewertungen)"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: data.url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                width: {
                                    base: "100%",
                                    md: "auto"
                                },
                                justifyContent: {
                                    base: "center",
                                    md: "flex-start"
                                },
                                mt: 4,
                                as: "a",
                                layerStyle: "link_button_blue",
                                fontSize: {
                                    base: "sm",
                                    md: "md"
                                },
                                children: [
                                    "Mehr erfahren",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                        ml: 1,
                                        as: IoChevronForward/* IoChevronForward */.m
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

}]);